import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "./Questionnaire/Navigation";
import questionnaireImages from "../../../assets/gi/Questionnaire";
import { buttonCSS, desktopCss } from "./general.style";
import { questionnaireContext } from "./QuestionnaireProvider";
import { useContext } from "react";
import Transition from "./Transition";
import white_v from "../../../assets/gi/white_v.svg";
import GIPatientHeader from "./components/GIPatientHeader";

const questions = [
  "diabetesMedicines",
  "bloodPressureMedicines",
  "bloodThinners",
  "nutritionalSupplement",
  "colonoscopyBefore",
];

export default function GIQuestionnaire() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { answers, updateAnswer, submit } = useContext(questionnaireContext);
  const { questionKey } = useParams();
  const questionIndex = questions.indexOf(questionKey);
  const questionsLength = questions.length;
  const nextQuestionKey = questions[questionIndex + 1];
  const handleAnswer = (answerKey) => () => {
    updateAnswer({ questionKey, answerKey });
    if (nextQuestionKey) return navigate(`../${nextQuestionKey}`);
    else submit();
  };

  return (
    <Transition>
      <QuestionContainer>
        <GIPatientHeader padding="0" />
        <QuestionImage src={questionnaireImages[questionKey]} />
        <Navigation index={questionIndex} questionsSize={questionsLength} />
        <QuestionText>
          {t(`Question-${questionKey}`)}
        </QuestionText>
        <ButtonsContainer key={questionKey}>
          <Answer onClick={handleAnswer("Yes")}>
            <Input
              name={questionKey}
              value="Yes"
              defaultChecked={answers.current[questionKey] === "Yes"}
            />
            <Vcheck />
            <AnswerText>
              {t("Yes")}
            </AnswerText>
          </Answer>
          <Answer onClick={handleAnswer("No")}>
            <Input
              name={questionKey}
              value="No"
              defaultChecked={answers.current[questionKey] === "No"}
            />
            <Vcheck />
            <AnswerText>
              {t("No")}
            </AnswerText>
          </Answer>
        </ButtonsContainer>
      </QuestionContainer>
    </Transition>
  );
}

const QuestionContainer = styled.div`
  ${desktopCss}

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding-inline: 20px;
  padding-block: 15px 60px;
  box-sizing: border-box;
`;

const QuestionText = styled.p`
  font-family: "Abraham", sans-serif;
  font-weight: 400;
  font-size: 1.1875rem;
  margin: 20px 0px 40px;
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.75rem;
`;

const QuestionImage = styled.img`
  width: 400px;
  max-width: 100%;
`;

const Input = styled.input.attrs({
  type: "radio",
  hidden: true,
})``;

const Vcheck = styled.img.attrs({
  src: white_v,
  alt: "V",
})`
  display: none;
  height: 1.5rem;
  width: 1.2rem;
`;

const AnswerText = styled.span`
  font-family: "Abraham", sans-serif;
  line-height: 1.5rem;
`;

const Answer = styled.label`
  ${buttonCSS}
  display: flex;
  justify-content: center;
  padding-block: 0.5rem;
  width: 6.7rem;
  max-width: 45%;
  &:hover {
    background-color: #f02a4c;
  }
  &:has(${Input}:checked) {
    span {
      display: none;
    }
    ${Vcheck} {
      display: block;
    }
  }
`;
